import { Title } from "@mantine/core";
import { L2KH1Props } from "./types";
import { H1_STYLE, COLORS } from "./constants";

/**
 * L2KH1 - Largest heading component
 * Renders as <h1> by default, uses Big Shoulders Display font
 * Responsive sizing: 48px → 64px across 320px → 1920px viewports
 */
export function L2KH1({
  children,
  variant = "primary",
  component = "h1",
  style,
  ...props
}: L2KH1Props) {
  return (
    <Title
      order={1}
      component={component}
      style={{
        fontSize: H1_STYLE.fontSize,
        lineHeight: H1_STYLE.lineHeight,
        letterSpacing: H1_STYLE.letterSpacing,
        fontWeight: H1_STYLE.fontWeight,
        fontFamily: H1_STYLE.fontFamily,
        margin: 0,
        color: COLORS[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
}
